import { render, staticRenderFns } from "./fdjscqy.vue?vue&type=template&id=51767fc0&scoped=true&"
import script from "./fdjscqy.vue?vue&type=script&lang=js&"
export * from "./fdjscqy.vue?vue&type=script&lang=js&"
import style0 from "./fdjscqy.vue?vue&type=style&index=0&id=51767fc0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51767fc0",
  null
  
)

export default component.exports